import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class PaymentsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    const filter = this.component.props.app.financeBankTransactionsFilterState;

    this.component.paginatorPath = `Finance_Bank_Transactions_${filter}`;

    this.component.setState({
      filter: filter,
      isSaving: false
    }, () => {
      this.component.fetchFirstAllPayments(() => {
        window.scrollTo({
          top: this.component.props.app?.financeBankTransactionsListPosition
        });
      });
      this.component.fetchFirstUnusedPayments(() => {
        window.scrollTo({
          top: this.component.props.app?.financeBankTransactionsListPosition
        });
      });
    });
  }
}

export default new PaymentsWillMount();
